module.exports = __webpack_public_path__ + "img/security.1251a92a.png";